import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(3.125),
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
}))

export default styles
